import { Navigate } from 'react-router-dom';

/**
 * Компонент защиты роутов
 * Перенаправляет на страницу логина, если пользователь не авторизован
 */
export default function ProtectedRoute({ children }) {
    if (!localStorage.user) {
        // Извлекаем язык из текущего пути
        const path = window.location.pathname;
        const parts = path.split('/').filter(Boolean);
        const LANG = ['ru', 'en', 'de'].includes(parts[1]) ? parts[1] : 'ru';
        
        return <Navigate to={`/${LANG}/login`} replace />;
    }
    return children;
}
